import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { ErrorBoundary } from './components/ErrorBoundary';
import Layout from './components/Layout';
import Dashboard from './pages/Dashboard';
import Settings from './pages/Settings';
import Research from './pages/Research';
import Inventory from './pages/Inventory';
import ListingDetail from './pages/ListingDetail';
import Costs from './pages/Costs';
import Recipes from './pages/Recipes';
import Help from './pages/Help';
import BatchGeneration from './pages/BatchGeneration';
import NicheAnalysis from './pages/NicheAnalysis';
import Analytics from './pages/Analytics';
import NotFound from './pages/NotFound';
import Trends from './pages/Trends';

function App() {
  return (
    <ErrorBoundary>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Layout />}>
            <Route index element={<Dashboard />} />
            <Route path="settings" element={<Settings />} />
            <Route path="research" element={<Research />} />
            <Route path="research/:id" element={<NicheAnalysis />} />
            <Route path="inventory" element={<Inventory />} />
            <Route path="listing/:id" element={<ListingDetail />} />
            <Route path="costs" element={<Costs />} />
            <Route path="recipes" element={<Recipes />} />
            <Route path="batch" element={<BatchGeneration />} />
            <Route path="trends" element={<Trends />} />
            <Route path="analytics" element={<Analytics />} />
            <Route path="help" element={<Help />} />
            <Route path="*" element={<NotFound />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </ErrorBoundary>
  );
}

export default App;
